import {css} from "lit";
import {customScrollStyles} from "../styles/CustomScrollBar.js";

export const dropdownSubmenuStyles = [customScrollStyles, css`
	:host {
		position: absolute;
		z-index: 1000;
		display: none;
		top: 0;
		left: 100%;
		margin-left: -8px;
		width: 140px;
	}

	.dropdown-menu {
		padding: 10px 0;
		display: block;
		max-height: 32vh;
		overflow-y: auto;
		position: static;
	}

	.dropdown-menu > li {
		display: block;
		.dropdown-item {
			padding: 10px 11px;
			&:hover {
				padding: 10px 11px;
			}
		}
	}


	> a {
		// Used in middle level submenus, such as project names under "Copy to Project"
		span {
			margin-right: 5px;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
`];
